module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg9-0d1dc631cded45410d3c7088150e7f85.jpg";